import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { setLegend } from "../../../../features/sharedSlice";
import { useAppSelector } from "../../../../store/hooks";

interface Props {
  style: string
  url?: string
}

export default function Legend(props: Props) {
  const { style } = props;
  const [text, setText] = useState<string>('')
  const functionalRoles = useAppSelector(state => state.sharedState.functionalRoles);
  const dispatch = useDispatch()

  useEffect(() => {
    switch (style) {
      case 'parsel_usr':
        setText('Tahsis Durumu')
        break;
      case 'parsel_niteligi':
        setText('Parsel Niteliği')
        break;
      case 'imar_durumu':
        setText('İmar Durumu')
        break;
      case 'asamasi':
        setText('Aşaması')
        break;
      case 'duzenlenecek_parsel':
        setText('Parsel Güncelle')
        break;
      default:
        break;
    }

    dispatch(setLegend({ url: `${props.url}/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&HEIGHT=10&LAYER=parsel_usr&style=${style}&legend_options=fontName:Times%20New%20Roman;fontAntiAliasing:true;fontColor:0xFFFFFF;fontSize:10;bgColor:0x1F2D40;dpi:180`, text: text }))

  }, [style])

  return (
    <div style={{ position: 'absolute', bottom: '3.894em', right: `${functionalRoles.findIndex((role: any) => role.function_id === 17) > -1 ? '3em' : '0.8em'}`, background: 'var(--surface-a)', padding: '0 1em 1em 1em', display: 'flex', alignItems: 'center', flexDirection: 'column', border: '2px solid var(--primary-color)' }}>
      {text && <p style={{ fontSize: '16px', fontWeight: '600' }}> {text}</p>}
      <img src={props.url + `/wms?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&HEIGHT=10&LAYER=parsel_usr&style=${style}&legend_options=fontName:Times%20New%20Roman;fontAntiAliasing:true;fontColor:0xFFFFFF;fontSize:10;bgColor:0x1F2D40;dpi:180`} alt="" />
    </div>
  )
}
